import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import FooterNavLink from './FooterNavLink';

export default class Footer extends Component {
  static propTypes = {
    showSocialLinks: PropTypes.bool,
    showTopBorder: PropTypes.bool,
  };

  static defaultProps = {
    showSocialLinks: true,
    showTopBorder: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      navList: [
        {
          to: '/Политика конфиденциальности CooperVision_2021_для сайта.pdf',
          label: 'Политика конфиденциальности',
        }
      ],
    };
  }

  render() {
    const { showSocialLinks, showTopBorder } = this.props;
    return (
      <footer className="footer">
        <div
          className="b-center"
          style={showTopBorder ? {} : { borderTop: 'none', paddingTop: '15px' }}
        >
          <div className="copyright">
            {`© ${(new Date()).getFullYear()} CooperVision`}
            <span className="copyright-saparation">&nbsp;|&nbsp;</span>
            {'Подразделение компании The Cooper Companies'}
          </div>

          <div className="footer-menu">
            {showSocialLinks && (
              <span className="footer-menu-social">
                <a
                  target="_blank"
                  href="https://www.instagram.com/coopervision_ru/"
                  className="footer-social-link"
                >
                  <img src="/Content/images/social/instagram.svg" alt="instagram" />
                </a>
                <a
                  target="_blank"
                  href="https://www.facebook.com/CooperVisionRussia/"
                  className="footer-social-link"
                >
                  <img src="/Content/images/social/facebook.svg" alt="facebook" />
                </a>
              </span>
             )}

                    <a href="/Политика конфиденциальности CooperVision_2021_для сайта.pdf" target="_blank">Политика конфиденциальности</a>
            {/*{this.props.navList.map((item, i) => {*/}
            {/*  return (*/}
            {/*    <FooterNavLink key={i} to={item.to}>*/}
            {/*       {item.label}*/}
            {/*    </FooterNavLink>*/}
            {/*    );*/}
            {/* })}*/}
          </div>
        </div>
      </footer>
    );
  }
}
